import { createIcon } from '@chakra-ui/react';

export const ChevronRight = createIcon({
  displayName: 'Chevron Right',
  viewBox: '0 0 50 50',
  path: (
    <>
      <title>Icons/UI System/Directional/Large/Chevron/Chevron Right - L</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path
          d="M13.912,1.40307403 C14.2948578,1.39805379 14.6629302,1.55083857 14.9296,1.82559995 L37.1056,24.04 C37.6671105,24.6022097 37.6671105,25.5129903 37.1056,26.0752 L14.9296,48.1552 C14.3622212,48.6838891 13.4780613,48.6682891 12.9296861,48.1199139 C12.3813109,47.5715387 12.365711,46.6873788 12.8944,46.12 L34.0144,25 L12.8944,3.87999996 C12.331783,3.31450098 12.331783,2.40069893 12.8944,1.83519995 C13.1638127,1.56330992 13.5292693,1.40816325 13.912,1.40307403 Z"
          id="path-2"
        />
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <mask id="mask-2" fill="white">
          <use xlinkHref="#path-2" />
        </mask>
        <g id="Chevron-Right---L" fillRule="nonzero" />
        <g mask="url(#mask-2)" fill="currentColor">
          <rect id="Rectangle" x="0" y="0" width="50" height="50" />
        </g>
      </g>
    </>
  ),
});
